import { IconX } from '@tabler/icons-react';
import { useModalA11y } from '../../utils/useModalA11y';
import './Modal.scss';

export default function Modal({
    open,
    title,
    onClose,
    children,
    footer,
    wide = false,
}) {
    const dialogRef = useModalA11y(open, onClose);

    if (!open) return null;

    return (
        <div className="admin-modal-overlay" onClick={onClose} role="presentation">
            <div
                ref={dialogRef}
                className={`admin-modal${wide ? ' admin-modal--wide' : ''}`}
                role="dialog"
                aria-modal="true"
                aria-labelledby="admin-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="admin-modal__header">
                    <h3 id="admin-modal-title">{title}</h3>
                    <button type="button" className="admin-modal__close" onClick={onClose} aria-label="Закрыть">
                        <IconX size={18} stroke={1.5} />
                    </button>
                </div>
                <div className="admin-modal__body">{children}</div>
                {footer && <div className="admin-modal__footer">{footer}</div>}
            </div>
        </div>
    );
}
